import React from 'react';

interface PersonaAvatarProps {
  name: string;
  specialization?: string;
  avatarUrl?: string;
  size?: 'small' | 'medium' | 'large';
}

export const PersonaAvatar: React.FC<PersonaAvatarProps> = ({
  name,
  specialization,
  avatarUrl,
  size = 'medium'
}) => {
  // Determine size class
  const sizeClass = {
    small: 'w-8 h-8 text-xs',
    medium: 'w-12 h-12 text-sm',
    large: 'w-20 h-20 text-xl'
  }[size];

  // Generate background color based on specialization
  const getBackgroundColor = () => {
    if (!specialization) return 'bg-gray-200';
    
    const specializationMap: Record<string, string> = {
      'technical': 'bg-blue-100 text-blue-700',
      'creative': 'bg-purple-100 text-purple-700',
      'analytical': 'bg-green-100 text-green-700',
      'research': 'bg-yellow-100 text-yellow-700',
      'communication': 'bg-pink-100 text-pink-700',
      'management': 'bg-indigo-100 text-indigo-700'
    };
    
    // Find a matching specialization or use a default
    const key = Object.keys(specializationMap).find(
      key => specialization.toLowerCase().includes(key)
    );
    
    return key ? specializationMap[key] : 'bg-gray-200 text-gray-700';
  };

  // Get initials from name
  const getInitials = () => {
    return name
      .split(' ')
      .map(part => part.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <div className={`persona-avatar ${sizeClass} rounded-full flex items-center justify-center font-bold ${getBackgroundColor()}`}>
      {avatarUrl ? (
        <img 
          src={avatarUrl} 
          alt={name} 
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <span>{getInitials()}</span>
      )}
    </div>
  );
};
